import { render, staticRenderFns } from "./TPADashboard.vue?vue&type=template&id=a111481e&scoped=true&"
import script from "./TPADashboard.vue?vue&type=script&lang=js&"
export * from "./TPADashboard.vue?vue&type=script&lang=js&"
import style0 from "./TPADashboard.vue?vue&type=style&index=0&id=a111481e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a111481e",
  null
  
)

export default component.exports